import clsx from 'clsx';

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
  disabledReason?: string;
  id?: string;
}

/** A dense, keyboard-operable toggle switch — Space/Enter flips it, native checkbox semantics underneath. */
export function Toggle({ checked, onChange, label, disabled, disabledReason, id }: ToggleProps) {
  return (
    <label
      htmlFor={id}
      title={disabled ? disabledReason : undefined}
      className={clsx(
        'inline-flex items-center gap-2',
        disabled ? 'cursor-not-allowed opacity-45' : 'cursor-pointer',
      )}
    >
      <span className="relative inline-flex h-[18px] w-[32px] shrink-0 items-center">
        <input
          id={id}
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
          className="peer absolute inset-0 h-full w-full cursor-pointer opacity-0 disabled:cursor-not-allowed"
        />
        <span
          className={clsx(
            'pointer-events-none absolute inset-0 rounded-full border transition-none',
            checked
              ? 'border-[var(--accent)] bg-[var(--accent)]'
              : 'border-[var(--border-strong)] bg-[var(--bg-inset)]',
            'peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-[var(--focus-ring)]',
          )}
        />
        <span
          className={clsx(
            'pointer-events-none absolute top-[2px] h-[12px] w-[12px] rounded-full bg-[var(--bg-elevated)] shadow-none transition-none',
            checked ? 'left-[16px]' : 'left-[2px]',
          )}
        />
      </span>
      {label && <span className="text-[12.5px]">{label}</span>}
    </label>
  );
}
